import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import { ThemeWrapper } from '@vitvio/design-system';
import { initializeLogging } from '@vitvio/logging';

import {
  ENVIRONMENT,
  KINDE_CLIENT_ID,
  KINDE_DOMAIN,
  LOGIN_REDIRECT_URI,
  LOGOUT_REDIRECT_URI,
  MIXPANEL_TOKEN,
  SENTRY_DSN,
  SENTRY_TRACES_SAMPLE_RATE,
} from './config';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';

import App from './app/app';
import { css, Global } from '@emotion/react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const logger = initializeLogging({
  environment: ENVIRONMENT,
  sentryDsn: SENTRY_DSN,
  sentryTracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  mixpanelToken: MIXPANEL_TOKEN,
});

logger.info('Platform application starting', { environment: ENVIRONMENT });

root.render(
  <StrictMode>
    <Global
      styles={css`
        body {
          overscroll-behavior-y: none;
        }
      `}
    />
    <KindeProvider
      clientId={KINDE_CLIENT_ID}
      domain={KINDE_DOMAIN}
      redirectUri={LOGIN_REDIRECT_URI}
      logoutUri={LOGOUT_REDIRECT_URI}
    >
      <ThemeWrapper>
        <App />
      </ThemeWrapper>
    </KindeProvider>
  </StrictMode>,
);
